export const chain = (...callbacks) => () => {
    for (const callback of callbacks) {
        if (typeof callback === 'function') {
            callback();
        }
    }
};
//# sourceMappingURL=chain.js.map